import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetAttachmentsAnswer = createAsyncThunk(
  "AC_NT_AT_AttachmentsAnswer/GetAttachmentsAnswer",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient("application/json");
      const apiClient = getApiClient();
      const response = await apiClient.post(
        "api/AC_NT_AT_AttachmentsAnswer/GetAttachmentsAnswer",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateAttachmentsAnswer = createAsyncThunk(
  "AC_NT_AT_AttachmentsAnswer/UpdateAttachmentsAnswer",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = getApiClient();
      const response = await apiClient.post(
        "api/AC_NT_AT_AttachmentsAnswer/UpdateAttachmentsAnswer",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const ValidationAttachments = createAsyncThunk(
  "AC_NT_AT_AttachmentsAnswer/ValidationAttachments",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = getApiClient();
      const response = await apiClient.post(
        "api/AttachmentsPageValidation/Validation",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const AttachmentsAnswer = createSlice({
  name: "AttachmentsAnswer",
  initialState: {
    //------------- GetAttachmentsAnswer ---------------------
    AttachmentsAnswer: [],
    loadingAttachmentsAnswer: false,
    errorAttachmentsAnswer: null,
    //------------- UpdateAttachmentsAnswer ---------------------
    UpdateAttachment: {},
    loadingUpdateAttachment: false,
    errorUpdateAttachment: null,
    //------------- UpdateAttachmentsAnswer ---------------------
    ValidationAttachments: [],
    loadingValidationAttachments: false,
    errorValidationAttachments: null,
  },
  reducers: {
    setAttachmentsAnswer: (state, action) => {
      state.AttachmentsAnswer = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetAttachmentsAnswer.pending, (state, action) => {
        console.log(action.payload, "action.payload");

        state.loadingAttachmentsAnswer = true;
        state.AttachmentsAnswer = action.payload;
        state.errorAttachmentsAnswer = null;
      })
      .addCase(GetAttachmentsAnswer.fulfilled, (state, action) => {
        state.loadingAttachmentsAnswer = false;
        state.AttachmentsAnswer = action.payload;
      })
      .addCase(GetAttachmentsAnswer.rejected, (state, action) => {
        state.loadingAttachmentsAnswer = false;
        state.AttachmentsAnswer = action.payload;
      });
    //------------------- UpdateAttachment -----------------------------------
    builder
      .addCase(UpdateAttachmentsAnswer.pending, (state, action) => {
        state.loadingUpdateAttachment = true;
        state.UpdateAttachment = action.payload;
        state.errorUpdateAttachment = null;
      })
      .addCase(UpdateAttachmentsAnswer.fulfilled, (state, action) => {
        state.loadingUpdateAttachment = false;
        state.UpdateAttachment = action.payload;
      })
      .addCase(UpdateAttachmentsAnswer.rejected, (state, action) => {
        state.loadingUpdateAttachment = false;
        state.errorUpdateAttachment = action.payload;
      });
      //------------------- Validation -----------------------------------
    builder
      .addCase(ValidationAttachments.pending, (state, action) => {
        state.loadingValidationAttachments = true;
        state.ValidationAttachments = action.payload;
        state.errorUpdateAttachment = null;
      })
      .addCase(ValidationAttachments.fulfilled, (state, action) => {
        state.loadingValidationAttachments = false;
        state.ValidationAttachments = action.payload;
      })
      .addCase(ValidationAttachments.rejected, (state, action) => {
        state.loadingValidationAttachments = false;
        state.errorValidationAttachments = action.payload;
      });
  },
});
export const { setAttachmentsAnswer } = AttachmentsAnswer.actions;

export default AttachmentsAnswer.reducer;
